import React from 'react'
//import backgroundImage from '../assets/tile-arrow-bg3.svg';
import { Link } from "react-router-dom";

const Tile = ({ title, image, link }) => {

    return (
        <div className="flex flex-col h-72 relative">
            <img src="https://insol.azureedge.net/cmsstorage/insol/media/education/icons/tile-arrow-bg3.svg" className="flex self-start h-full w-full object-cover" />
            <div className="absolute bottom-0 w-full p-6 bg-brandMidBlue bg-contain bg-no-repeat bg-right" style={{ backgroundImage: `url("/frontend/assets/tile-arrow-bg3.svg")` }}>
                <h2 className="section-title text-1xl text-white font-bold">{title}</h2>
            </div>
            <a href={link} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</a>
        </div>
    );
};

export default Tile;